import { Link } from 'react-router-dom'

/**
 * Art-13-DSGVO-Information zur Zeiterfassung (Beschäftigtendaten) — für JEDEN Mitarbeiter einsehbar.
 *
 * WICHTIG (Rollenklarheit): Verantwortliche im Sinne der DSGVO ist die WERKSTATT (der Arbeitgeber), nicht Cevio.
 * Cevio ist Auftragsverarbeiter (Software), Cloudflare Sub-Auftragsverarbeiter (Hosting, EU). Dieses Blatt ist
 * daher ein MUSTER, das Cevio bereitstellt: die fixen, tatsächlich zutreffenden Angaben (Rechtsgrundlagen,
 * EU-Residenz, Verarbeiter, Aufbewahrung) sind ausgefüllt; die werkstatt-spezifischen Angaben (Name/Kontakt des
 * Arbeitgebers, ggf. Datenschutzbeauftragter, Lohnbüro) trägt der Betrieb selbst ein. Bewusst KEINE erfundenen
 * Firmendaten — die Lücken sind ehrlich als „vom Arbeitgeber zu ergänzen" markiert (Simons Linie, wie LegalPage).
 */
export function Art13Page() {
  return (
    <section className="wf-view">
      <div className="wf-viewhead">
        <div>
          <h2 className="viewtitle">Datenschutz-Info zur Zeiterfassung</h2>
          <p className="sub">Wie deine Arbeitszeit-Daten verarbeitet werden (Art. 13 DSGVO)</p>
        </div>
      </div>

      <article className="wf-card wf-a13">
        <p className="wf-a13__muster" role="note">
          <b>Muster-Vorlage.</b> Die mit <span className="wf-a13__todo">vom Arbeitgeber zu ergänzen</span> markierten
          Angaben trägt deine Werkstatt ein. Bei Fragen wende dich an die Geschäftsführung deines Betriebs.
        </p>

        <h3 className="wf-a13__h">1. Wer ist verantwortlich?</h3>
        <p>
          Verantwortlich für die Verarbeitung deiner Arbeitszeit-Daten ist dein <b>Arbeitgeber</b> — die Werkstatt,
          bei der du beschäftigt bist. Name, Anschrift und Kontakt:{' '}
          <span className="wf-a13__todo">vom Arbeitgeber zu ergänzen</span>. Ein Datenschutzbeauftragter ist, sofern
          bestellt, dort zu erreichen (<span className="wf-a13__todo">vom Arbeitgeber zu ergänzen</span>).
        </p>

        <h3 className="wf-a13__h">2. Welche Daten und wozu?</h3>
        <p>
          Erfasst werden deine <b>Stempelzeiten</b> (Kommen/Gehen/Pause), auf Aufträge gebuchte <b>Arbeitszeiten</b>,
          <b> Korrekturen</b> (mit Grund und Urheber) sowie <b>Arbeitszeit-Hinweise</b> nach dem Arbeitszeitgesetz.
          Bei unter 18-Jährigen zusätzlich das <b>Geburtsdatum</b> — einziger Zweck ist der gesetzliche Jugendschutz
          (JArbSchG: strengere Grenzen für Arbeitszeit, Pausen, Freizeit und Beschäftigungszeiten).
          Zwecke: Erfassung und Nachweis der Arbeitszeit, Lohn-/Gehaltsabrechnung, Einhaltung von Arbeitszeit- und
          Mindestlohn-Pflichten sowie die Kalkulation von Aufträgen.
        </p>

        <h3 className="wf-a13__h">3. Auf welcher Rechtsgrundlage?</h3>
        <ul className="wf-a13__list">
          <li>Art. 6 Abs. 1 lit. b DSGVO — Durchführung deines Arbeitsvertrags,</li>
          <li>
            Art. 6 Abs. 1 lit. c DSGVO — gesetzliche Pflichten (u. a. Arbeitszeitgesetz, § 17 Mindestlohngesetz,
            handels- und steuerrechtliche Aufbewahrung nach GoBD, § 257 HGB, § 147 AO),
          </li>
          <li>§ 26 BDSG — Verarbeitung von Beschäftigtendaten im Rahmen des Arbeitsverhältnisses.</li>
        </ul>

        <h3 className="wf-a13__h">4. Wer bekommt die Daten?</h3>
        <p>
          Für Software und Betrieb: <b>Cevio</b> als Auftragsverarbeiter deines Arbeitgebers und, als
          Sub-Auftragsverarbeiter, <b>Cloudflare</b> (Hosting; Server in der Europäischen Union). Für die Abrechnung
          ggf. das <b>Lohnbüro / der Steuerberater</b> deines Betriebs (
          <span className="wf-a13__todo">vom Arbeitgeber zu ergänzen</span>). Im Rahmen gesetzlicher Prüfungen können
          <b> Finanzbehörden</b> Einsicht verlangen (GoBD).
        </p>

        <h3 className="wf-a13__h">5. Wo werden die Daten verarbeitet?</h3>
        <p>
          Ausschließlich in der <b>Europäischen Union</b> — es findet keine Übermittlung in ein Drittland statt.
        </p>

        <h3 className="wf-a13__h">6. Wie lange werden sie gespeichert?</h3>
        <p>
          So lange, wie es das Arbeitsverhältnis und die gesetzlichen Aufbewahrungsfristen erfordern: abrechnungs- und
          buchführungsrelevante Zeitdaten in der Regel <b>6 bis 10 Jahre</b> (GoBD, § 257 HGB, § 147 AO);
          Arbeitszeit-Nachweise nach dem Arbeitszeitgesetz mindestens <b>2 Jahre</b>. Danach werden die Daten gelöscht
          bzw. anonymisiert.
        </p>

        <h3 className="wf-a13__h">7. Deine Rechte</h3>
        <p>
          Du hast das Recht auf <b>Auskunft</b> (Art. 15), <b>Berichtigung</b> (Art. 16), <b>Löschung</b> (Art. 17,
          soweit keine Aufbewahrungspflicht entgegensteht), <b>Einschränkung</b> (Art. 18),
          <b> Datenübertragbarkeit</b> (Art. 20) und <b>Widerspruch</b> (Art. 21). Wende dich dafür an deinen
          Arbeitgeber. In dieser App kannst du deinen eigenen Monatsnachweis jederzeit einsehen und Korrekturen
          beantragen.
        </p>

        <h3 className="wf-a13__h">8. Beschwerderecht</h3>
        <p>
          Du kannst dich bei der zuständigen Datenschutz-Aufsichtsbehörde beschweren (die Aufsichtsbehörde des
          Bundeslandes deines Arbeitgebers, <span className="wf-a13__todo">vom Arbeitgeber zu ergänzen</span>).
        </p>

        <h3 className="wf-a13__h">9. Musst du die Daten bereitstellen?</h3>
        <p>
          Ja. Die Erfassung deiner Arbeitszeit ist gesetzlich und vertraglich erforderlich; ohne sie können Arbeitszeit
          und Lohn nicht ordnungsgemäß nachgewiesen und abgerechnet werden.
        </p>

        <h3 className="wf-a13__h">10. Automatische Entscheidungen?</h3>
        <p>
          Nein. Es findet <b>keine automatisierte Entscheidungsfindung</b> und kein Profiling statt. Die
          Arbeitszeit-Hinweise (z. B. „Pause fällig") sind reine Erinnerungen — Entscheidungen trifft immer ein Mensch.
        </p>

        <div className="wf-a13__foot">
          <Link to="/zeiten" className="wf-btn wf-btn--ghost">
            Zurück zu „Meine Zeit"
          </Link>
        </div>
      </article>
    </section>
  )
}
